// Функция необходима, потому как высота элемента порой может отличаться на 1-2 пикселя при одинаковых условиях
// и стандартный метод округления в этом случае приводит к визуальным багам
export function stableRound(value: number) {
  const decimalPart = value % 1;

  if (decimalPart >= 0.7) {
    return Math.ceil(value);
  }

  return Math.floor(value);
}
